import { useState } from "react";
import { Button, Nav, Offcanvas } from "react-bootstrap";
import { BsCalendar2X } from "react-icons/bs";
import PlaningAuditBlock from "../personal/PlaningAuditPage/PlaningAuditBlock";


export const CreateAuditOffcanvass = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return(
        <>  
            {/* <div onClick={()=>handleShow()}>
            <Nav.Link 
                className="icon_label_block">
                    <BsCalendar2X/>
                    <span className="icon_text">Организовать аудит</span>
            </Nav.Link>
            </div> */}
            <Button onClick={()=>handleShow()} className="border" variant="light"><BsCalendar2X/></Button>
            
            <Offcanvas show={show} onHide={handleClose} style={{ maxWidth:"600px", width:"600px"}} placement="end">
                 <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Организовать аудит</Offcanvas.Title>
                 </Offcanvas.Header>
                 <Offcanvas.Body>
                    <PlaningAuditBlock/>
                 </Offcanvas.Body>
            </Offcanvas>

        </>
    )
}